import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";

const contactusurl ="api/v2/email";
const emailSubscriptionUrl = "/api";

export interface SubscribeToListApiParameter extends ApiParameter {
    emailAddress: string;
    
}

export interface DSGSubscribeParameter {
    email: string;
}
export interface SubmitContactUsFormApiParameter extends ApiParameter {
    topic?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    emailAddress?: string;
    message?: string;
    emailTo?: string;
    companyName?:string;
    cityName?:string;
    state?:string;
    contactPreference?:string;
    smsOptIn?:string;
}
export interface SubmitDsgPlusFormApiParameter extends ApiParameter {
    firstName?: string;
    lastName?: string;
    customerNumber?: string;
    emailAddress?: string;
    message?: string;
    emailTo?: string;
    jobtitle?:string;
    phoneNumber?: string;
    topic?: string;
    companyName?:string;
    hearaboutoption?:string;
    salesperson?:string;
    explain?:string;
    socialmedia?:string;
    preferredBranch?: string;  
    smsOptIn?:string;
}
export  function subscribeToList(
    parameter: DSGSubscribeParameter,
): Promise<any> {
    return post<DSGSubscribeParameter>(
        `${emailSubscriptionUrl}/SubscribeToList`,parameter
    ).then((result)=>{
        return result;
    }).catch(()=>{
        return false
    });
}
export function submitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    return post<SubmitContactUsFormApiParameter, void>(`${contactusurl}/contactUs`, parameter);
}


export function submitDsgPlusForm(parameter: SubmitDsgPlusFormApiParameter) {
    return post<SubmitDsgPlusFormApiParameter, void>(`${contactusurl}/dsgPlusUs`, parameter);
}